var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClockBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 13.242C2.94211 13.242 0 10.3519 0 6.74454C0 3.13721 2.925 0.244543 6.5 0.242004C10.0579 0.242004 13 3.20274 13 6.742C13 10.3493 10.1263 13.242 6.5 13.242ZM6.5 1.242C3.28421 1.242 1 3.54305 1 6.742C1 9.94096 3.28421 12.242 6.5 12.242C9.71579 12.242 12 9.94349 12 6.74454C12 3.47753 9.71579 1.242 6.5 1.242Z",
    fill: "#03A9F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6927 9.79275C8.79432 9.89267 8.89594 9.99259 9.09917 9.99259C9.20079 9.99259 9.32861 9.96684 9.50565 9.79275C9.70888 9.5929 9.70888 9.29313 9.50565 9.09328L7.01324 6.5592V2.83623C7.01324 2.43653 6.81001 2.23668 6.50516 2.23668C6.2003 2.23668 5.99707 2.53646 5.99707 2.83623V6.85898C5.99707 6.9589 6.09869 7.15875 6.20031 7.25867L8.6927 9.79275Z",
    fill: "#03A9F4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockBlue);
export default __webpack_public_path__ + "static/media/clock-blue.708a2938a434a15852924f6d25356cd3.svg";
export { ForwardRef as ReactComponent };